<p-confirmDialog header="Deleting Final Confirmation"></p-confirmDialog>
<p-table [value]="templateService.finalConfirmationTemplates">
    <ng-template pTemplate="header">
        <tr>
            <th>
                ID
            </th>
            <th>
                Name
            </th>
            <th>
                Action
            </th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-template>
        <tr>
            <td>
                {{template.id}}
            </td>
            <td>
                <a (click)="selectTemplateToEdit(template)" class="template-select-link">
                    <p>Final confirmation template {{template.name}}</p>
                </a>
            </td>
            <td>
                <p-button icon="pi pi-trash" styleClass="p-button-danger" (onClick)="deleteTemplate(template.id)"></p-button>
            </td>
        </tr>
    </ng-template>
</p-table>